<style lang="scss">
  @import '../resources/scss/id_details.scss';
</style>

<script lang="ts">
  import type DetailsSection from '../api/rest/directus-cms/investigation/models/DetailsSection'

  export let details: DetailsSection
</script>

{#if details}
  <div class="container-fluid py-section bg-primary-c text-white">
    <div class="container-xxl flex-grow-1">
      <div class="row">
        <div class="col-12 col-xl-8">
          <div class="details-container">
            <h1 class="text-break">{details.title}</h1>
            <h4 class="mt-4 mb-0">{@html details.message}</h4>
          </div>
        </div>
        <div class="col-12 col-xl-4">
          <div
            class="d-flex justify-content-center align-items-center h-100 icon-container flex-wrap"
          >
            <div class="d-flex justify-content-center align-items-center mt-4 mt-xl-0">
              <img
                class="align-self-center"
                src={details.icons[0].icon?.fullUrl}
                alt={details.icons[0].description}
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
{/if}
